import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { APIURL } from "../config";
import './registerpage.css'

function PasswordReset() {
    const [token, setToken] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(true);
    const [buttonText, setButtonText] = useState("Submit");
    const toggleShowPassword = () => setShowPassword(!showPassword);
    const toggleShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);


    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setToken(queryParams.get('token') || "");
    }, []);

    const handleRegistration = async () => {
        setPasswordError("");
        setConfirmPasswordError("");
        setError("");
        setButtonText("Submitting...");
        setEnableSubmit(false);

        let isValid = true;

        if (!password) {
            setPasswordError("Password is required.");
            isValid = false;
        } else {
            const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

            if (!passwordRegex.test(password)) {
                setPasswordError("Password must be at least 8 characters long, contain one uppercase letter and one number.");
                isValid = false;
            }
        }

        if (!confirmPassword) {
            setConfirmPasswordError("Please confirm your password.");
            isValid = false;
        } else if (password !== confirmPassword) {
            setConfirmPasswordError("Passwords do not match.");
            isValid = false;
        }
        console.log("isValid1: ", isValid)
        if (isValid == false) {
            setError("Please fill in all fields correctly.");
            setButtonText("Submit");
            setEnableSubmit(true);
            return;
        }

        try {
            const response = await axios.post(APIURL + '/reset-password', {
                newPassword: password,
                token: token
            });

            if (response.status === 403)
                setError("Password reset link has expired. Please request a new one.");
            else if (response.status === 200) {
                navigate("/login");
            } else {
                setError("An error occurred. Please try again.");
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
        }
        setButtonText("Submit");
        setEnableSubmit(true);
    }

    return (
        <div>
            <div className="loginsignup">
                <div className="loginsignup-container">
                    <h1>Reset Password</h1>
                    <div className="loginsignup-fields">
                        <label>
                            Password
                            <br />

                            <div className="password-container">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="password-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter your password"
                                />
                                <span style={{
                                    position: 'absolute',
                                    right: '10px',
                                    cursor: 'pointer',
                                    color: "#6c6c7d"
                                }} className="eye-button" onClick={toggleShowPassword}>
                                    {
                                        showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />
                                    }              </span>
                            </div>
                            <span style={{ color: "red" }}>{passwordError}</span>
                        </label>
                        <br />
                        <label>
                            Confirm Password
                            <br />
                            <div className="password-container">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="password-input"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Enter confirm password"
                                />
                                <span style={{
                                    position: 'absolute',
                                    right: '10px',
                                    cursor: 'pointer',
                                    color: "#6c6c7d"
                                }} className="eye-button" onClick={toggleShowConfirmPassword}>
                                    {
                                        showConfirmPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />
                                    }              </span>
                            </div>
                            <span style={{ color: "red" }}>{confirmPasswordError}</span>
                        </label>
                    </div>
                    <br />
                    <button className={`submit-button ${!enableSubmit && "disable"}`} onClick={handleRegistration} disabled={!enableSubmit}>
                        {buttonText || "Submit"}
                    </button>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                    <br />
                    <br />

                    <a
                        style={{ cursor: "pointer" }}
                        className="register"
                        onClick={() => navigate("/login")}
                    >
                        Sign-in here
                    </a>
                    <br />
                    <br />
                </div>
            </div >
        </div >
    )
}

export default PasswordReset